import {MetadataStructure} from '../filter/stateListResult.model';

export class GroupingConfiguration {
  id: number;
  groupingName: string;
  metadataStructure: MetadataStructure;
  domain: Array<string>;

  constructor () {
    this.metadataStructure = new MetadataStructure();
    this.domain = [];
  }
}

